import { Components, Theme } from "@mui/material/styles";
import TYPOGRAPHY from "../../../theme/typography";

export const MuiTypography: Components<Theme>["MuiTypography"] = {
    styleOverrides: {
        root: {
            lineHeight: TYPOGRAPHY.lineHeights.base,
        },
    },
};
